/* eslint-disable @typescript-eslint/no-explicit-any */
import * as Sentry from '@sentry/vue';

import { CUSTOM_TAG_VALUE } from '@/constants';

interface iConfig {
	url: string;
	baseURL: string;
	method: string;
}

export async function createSentryTransaction(baseURL: string, url: string, method: string, op: any, data: any) {
	return Sentry.startTransaction({
		name: url,
		op,
		description: method.toUpperCase() + ' ' + baseURL + url,
		data,
	});
}

export async function onHandleCreateTransaction(config: iConfig) {
	const configObject = {
		url: config.url,
		baseURL: config.baseURL,
		method: config.method,
	};

	return createSentryTransaction(
		config.baseURL,
		config.url,
		config.method,
		CUSTOM_TAG_VALUE.HTTP_CLIENT,
		configObject,
	);
}

export function createSpan(transaction: any, result: any, op: any, description: any) {
	return transaction.startChild({
		data: {
			result,
		},
		op,
		description,
	});
}

export function onCreateCustomTag(transaction: any, key: string, value: string) {
	transaction.setTag(key, value);
}

export function onResponseSentryTransaction(transaction: any, status: number) {
	transaction.setHttpStatus(status);
	transaction.finish();
}

export function onErrorSentryTransaction(transaction: any, error: any, status: number) {
	transaction.setHttpStatus(status);
	Sentry.captureException(error);
	transaction.finish();
}
